module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAAAyUlEQVR4AWOgC5CcyyA+h0F1MV/YdheX9fr267RCtjvF7/Z132hit1bTb7O1+mIBoAKgMoQGoVkMrhuMDj7dNelCW83xvOmXexZenz75YkfL6fIt91f7brYCKkDRIDqbwWCZ1PxrU5bcmNVyqnz93eVADW2nK5tOlQIZCbv9BWaiahCbw2C8QibvYFz4dtf4Xb7+W2wd1ml7b7II2GobsMXWerUq0ESEhv9EA5wa5s+fP2fOHBI0HAADTHFynXROUI1IRAcNgxIAACDqFcz3ADGOAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/_somaliland.png
// module id = 1322
// module chunks = 0